module.exports = __webpack_public_path__ + "static/media/ring-alt.f12aba43.svg";